import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { of, Subject } from 'rxjs';
import { catchError, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { SubscriptionWithDestroyTriggerComponent } from 'src/app/subscription-helpers/subscription-with-destroy-trigger.component';
import { ClientCornerHomePageColleague } from './helper/client-corner-home-page-colleague';
import { ClientCornerHomePageColleagueListControllerRequestService } from './service/client-corner-home-page-colleague-list-controller-request.service';

@Component({
  selector: 'client-corner-home-page-colleague-list',
  templateUrl: './client-corner-home-page-colleague-list.component.html',
  styleUrls: ['./client-corner-home-page-colleague-list.component.scss'],
})
export class ClientCornerHomePageColleagueListComponent
  extends SubscriptionWithDestroyTriggerComponent
  implements OnInit, OnChanges
{
  @Input()
  selectedCompanyId: number;

  displayedColumns = [
    'name',
    'phoneNumber',
    'mobileNumber',
    'email',
    'lastLogin',
  ];

  colleagues: ClientCornerHomePageColleague[];

  loading: boolean = false;
  fetchColleaguesSubject = new Subject<any>();

  constructor(
    private clientCornerHomePageColleagueListControllerRequestService: ClientCornerHomePageColleagueListControllerRequestService
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSubscription(
      this.fetchColleaguesSubject.pipe(
        startWith([]),
        switchMap(async () => {
          this.loading = true;
          return this.selectedCompanyId == null
            ? null
            : await this.clientCornerHomePageColleagueListControllerRequestService.colleagues(
                this.selectedCompanyId
              );
        }),
        catchError(() => of([])),
        takeUntil(this.destroyThisComponent)
      ),
      (colleagues: ClientCornerHomePageColleague[]) => {
        this.colleagues = colleagues;
        this.loading = false;
      }
    );
    this.fetchColleaguesSubject.next();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.selectedCompanyId) {
      this.fetchColleaguesSubject.next();
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.fetchColleaguesSubject != null) {
      this.fetchColleaguesSubject.complete();
    }
  }

  trackByUserId(index: number, obj: ClientCornerHomePageColleague): number {
    return obj.userId;
  }
}
